<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-12  transparent-bg">
              <b-card-body id="phone-login-form">
                <b-form>
                  <h1 class="text-light">{{$t('enduser_phone_direct_charging.title')}} <img class="navbar-brand-full" src="img/innoknight/logo.png" width="37" height="48" alt="InnoKnight"></h1>
                  <p class="text-light">{{$t('enduser_phone_direct_charging.description')}}</p>
                  
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-phone"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="tel" 
                                  class="form-control" 
                                  :placeholder="$t('enduser_phone_direct_charging.email_placeholder')" 
                                  pattern="\d*"
                                  v-model.lazy.trim="$v.username.$model"
                                  v-focus
                                  :state="chkState('username')"
                                  aria-describedby="invalidEmailFeedback"
                                  ref="username"
                                  maxLength="10"/>
                    <b-form-invalid-feedback id="invalidEmailFeedback">{{$t('enduser_phone_direct_charging.invalidEmailFeedback')}}</b-form-invalid-feedback>
                  </b-input-group>
                  
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-grav"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="number"
                                  name="token"
                                  inputmode="numeric"
                                  pattern="\d*"
                                  class="form-control" 
                                  :placeholder="$t('enduser_phone_direct_charging.token_placeholder')"
                                  v-model.lazy.trim="$v.token.$model"
                                  :state="chkState('token')"
                                  aria-describedby="invalidTokenFeedback"
                                  ref="token"
                                  autocomplete="one-time-code"/>
                    <b-form-invalid-feedback id="invalidTokenFeedback">{{$t('enduser_phone_direct_charging.invalidTokenFeedback')}}</b-form-invalid-feedback>
                    <b-button variant="success" :disabled="!($v.username.cellphone&&$v.username.required) || disable_get_token_btn" class="px-4" @click="getToken()">{{$t('enduser_phone_direct_charging.getToken')}}</b-button>
                    <span class="d-inline-block w-100 text-warning" v-if="is_get_token_clicked">{{$t('enduser_phone_direct_charging.getTokenRemarks', { counting })}}</span>
                  </b-input-group>

                  <!--<b-input-group v-if="true || showYourOkay" class="mb-4">
                    <b-button variant="success" :disabled="!$v.token.required||phonelogin_processing" class="col-12" @click="loginByPhoneAndToken()">{{$t('enduser_phone_direct_charging.loginByPhoneAndToken')}}</b-button>
                    <span class="text-center d-inline-block w-100 text-warning" v-if="phonelogin_processing">{{$t('enduser_phone_direct_charging.phonelogin_processing')}}</span>
                  </b-input-group>

                  <b-input-group v-if="askForToppingUp">
                    <b-alert class="col-12" variant="warning" show>
                      <i class="fa fa-exclamation-circle"></i> &nbsp;
                      {{toppingMsg}}
                    </b-alert>
                  </b-input-group>-->

                  <b-row>
                    <b-col cols="12">
                      <b-button variant="success" :disabled="!$v.token.required||phonelogin_processing" class="col-12" @click="loginByPhoneAndToken()">{{$t('enduser_phone_direct_charging.loginByPhoneAndToken')}}</b-button>
                      <span class="text-center d-inline-block w-100 text-warning" v-if="phonelogin_processing">{{$t('enduser_phone_direct_charging.phonelogin_processing')}}</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" class="text-center text-light" style="padding-top:1.2rem;">
                      <h5 class="d-inline pointer" @click="gotoLogin()"><i class="fa fa-sign-in"></i> {{$t('enduser_phone_direct_charging.gotoLogin')}} &nbsp;&nbsp;</h5>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <div class="mt-3 ml-auto text-white pri-info-declaration text-center">
                        <span v-html="PrivacyPolicy"></span> 
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <div class="ml-auto text-white pri-info-declaration text-center">
                        {{$t('innoknight') + '©' + thisyear}}
                      </div>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>

    <div class="hidden" id="tmp-form"></div>
  </div>
</template>

<script>
import { required, minLength, between, email, sameAs, maxLength } from 'vuelidate/lib/validators'
import VueNotifications from 'vue-notifications'
import config from '@/config/global'
import notifications from '@/config/notifications'
import _ from 'lodash'
import math from 'mathjs'

const encrypt  = config.encrypt;
const decrypt  = config.decrypt;
const api_root = config.api_root;

const _defaultNav = [
  { name:'充電裝置', url: '/dashboard/showdevice', icon: 'fa fa-plug' },
  { name:'充電紀錄', url: '/dashboard/history', icon: 'fa fa-bar-chart' },
  { name:'交易紀錄', url: '/dashboard/transactions', icon: 'fa fa-credit-card' },
  { name:'充電地圖', url: '/dashboard/maps', icon: 'fa fa-map-marker' },
  { name:'會員專區', url: '/dashboard/members-setting', icon: 'fa fa-users' },
];

const cellphone = (value) => {
  const phoneRegex = /^09\d{8}$/;
  return phoneRegex.test(value || '') ;
};

const generateRandomToken = () => {
  // 使用 36 進位，並串接兩個隨機數來增加長度
  const part1 = Math.random().toString(36).slice(2).toUpperCase();
  const part2 = Math.random().toString(36).slice(2).toUpperCase();
  const part3 = Math.random().toString(36).slice(2).toUpperCase();
  return `${part1}${part2}${part3}`; 
};

export default {
  name: 'EndUserDirectCharging',
  
  notifications,

  beforeMount() {
  },//eo beforeMount

  data() {

    let username = this.$state.$get('username');
    const this_year = new Date();
    
    username = username === 'null' ? '' : username;

    return {
      username:              username || '',
      token:                 '',
      captcha_action:        '',
      toppingMsg:            '',
      show_capthca:          config.show_capthca,
      captcha_action:        config.captcha_action,
      submit_btn_disabled:   true,
      is_get_token_clicked:  false,
      askForToppingUp:       false,
      showYourOkay:          false,
      counting:              60,
      disable_get_token_btn: false,
      thisyear: this_year.getFullYear(),
      footer: config.footer,
      phonelogin_processing: false
    };
  },//eo data

  mounted() {
    if (this.username && this.chkState('username')) {
      //this.getToken();
    }
  }, // eo mounted

  computed: {
    PrivacyPolicy() {
      const link = `<a href="https://law.moj.gov.tw/LawClass/LawAll.aspx?PCode=I0050021" target="_blank">${this.$t('personal_data_protection_act')}</a>`;
      return this.$t('privacy_policy_message', { link });
    }
  },//eo computed

  methods: {
    chkState(val) {
      const field = this.$v[val];
      return !field.$dirty || !field.$invalid;
    },//eo chkState

    gotoLogin() {
      this.$state.$del('user');
      this.$router.push('/');
    },//eo gotoLogin

    getToken(){
      let app = this;

      if(app.is_get_token_clicked){
        return false;
      }

      app.is_get_token_clicked = true;

      // let _cc = setTimeout(() => {
      //   app.is_get_token_clicked = false;
      // }, 90000);

      this.disable_get_token_btn = true;

      let _vc = setInterval(() => {
        if (this.counting-- <= 0) {
          this.is_get_token_clicked = false;
          this.disable_get_token_btn = false;
          this.counting = 60;
          clearInterval(_vc);
        }
      }, 1000);

      grecaptcha.execute(config.captcha_key, {action: 'resetpassword'})
      .then(function(ggtoken) {

        let username = app.username;
        let action   = `${api_root}/enduser/phone_login_send_token`;
        let params   = {
          keyset: 'mqtt',
          username: encodeURIComponent(encrypt(JSON.stringify({username}))),
          ggtoken,
        };

        fetch(action, {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + generateRandomToken()
          },
          body: JSON.stringify(params)
        }).then(res => res.json()).then(result => {
          if(!result.success){
            if(result.message === 'RECAPTCHA_FAIL'){
              app.showError({
                message: app.$t('enduser_phone_direct_charging.error.recaptcha_fail'),
                timeout: 15000
              });
            } else {
              app.showError({
                message: app.$t('enduser_phone_direct_charging.error.token_others_error'),
                timeout: 15000
              });
            }
          } else {
            let message;
            if(result.to_email) {
              //console.info('result.to_email:', result.to_email);
              message = app.$t('enduser_phone_direct_charging.token_email_sent', { email : result.to_email});
            } else {
              message = app.$t('enduser_phone_direct_charging.token_sent', { username });
            }
            app.showSuccess({
              message,
              timeout: 15000
            });
            //app.targetToken = result.token ? result.token : null;
            app.targetUUID = result.uuid;
          }
        }).catch(error => {
        });  
      });
    },//eo getToken
    
    loginByPhoneAndToken() {
      let app = this;
      if ( !this.username || !this.chkState('username')) {
        this.$refs.username.focus();
        this.showError({message: this.$t('enduser_phone_direct_charging.error.incorrect_phone_number')});
        return;
      } else {
        this.$state.$set('username', this.username);
      }

      if (!this.token /*|| (this.token !== this.targetToken)*/) {
        this.$refs.token.focus();
        this.showError({message: this.$t('enduser_phone_direct_charging.error.invalid_token')});
        return;
      }
      
      if (this.token /*&& (this.token === this.targetToken)*/) {
        let after = (google_captcha) => {
          google_captcha = google_captcha || null;
          let username = this.username;
          let token    = this.token;
          app.phonelogin_processing = true;
          let phone_register_action   = `${api_root}/enduser/phone_register_login`;
          let auth_token = generateRandomToken();
          fetch(phone_register_action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + auth_token
            },
            body: JSON.stringify({
              keyset: 'mqtt',
              form: encodeURIComponent(encrypt(JSON.stringify({
                username,
                token,
                google_captcha
              }))),
            })
          }).then(res => res.json()).then(result => {
            if (result.success) {
              let action = `${config.mqtt_root}/read_balance`;
              fetch(action, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + result.token
                },
                body: JSON.stringify({
                  user_id: encodeURIComponent(encrypt(`${result.uuid}`)),
                  keyset: 'mqtt',
                  operation: 'a-bit',
                  username: this.username,
                })
              }).then(res => res.json()).then(result2 => {
                if (result2.success) {
                  this.$state.$set('user', {
                    uuid: result2.newUUID,
                    token: result.token, //encrypt token for security issue.
                    ccff: 0,
                    name: result2.user.name,
                    username: result2.user.name,
                    email: result2.user.email,
                    _nav: _defaultNav,
                    credits: result2.user.credits,
                    bonus: result2.user.bonus,
                  });

                  let device_id = this.$state.$get('device_id');
                  let pre_uuid = this.$state.$get('uuid');
                  let postfix = device_id ? `?uuid=${device_id}` : '';

                  // console.info(result2.user);

                  if (pre_uuid) {
                    postfix = `?uuid=${encodeURIComponent(pre_uuid)}`;
                  }

                  this.showSuccess({message: this.$t('enduser_phone_direct_charging.phone_direct_charging_success')});
                  let keyword = this.$state.$get('keyword');
                  if(keyword) {
                    //console.info('EndUserPhoneDirectCharging2 2 keyword:', keyword);
                    window.location.href = '/#/search/devices?keyword=' + encodeURIComponent(keyword);
                  } else {
                    window.location.href = '/#/dashboard/showdevice' + postfix;
                  }   
                } else {
                  this.showError({message: result2.message}); //TODO: i18n
                }
              }).catch(error => {
              });
            } else {
              this.showError({message: result.message}); //TODO: i18n
            }
            app.phonelogin_processing = false;
          }).catch(error => {
            app.phonelogin_processing = false;
          });
          // console.info('this.targetUUID: ', this.targetUUID);
        }
        
        grecaptcha.execute(config.captcha_key, {action: 'login'})
        .then(function(ggtoken) {
          // console.info('grecaptcha.token:', token);
          after(ggtoken);
        });
      }
    },
  },//eo methods

  validations: {
    username: {
      cellphone,
      required,
      minLength: minLength(5)
    },
    token: {
      required,
      minLength: minLength(6)
    },
  }//eo validations
}
</script>

<style>
#phone-login-form {
  
}
.card-body{
  padding: 1.25rem !important;
}
.pointer{
  cursor: pointer;
}
.grecaptcha-badge{
  display: none;
}
.top-up-btn{
  height: 5rem;
  max-width: 100%;
  min-width: 100%;
  font-size: 1.5rem;
  margin: 0.5px 0px;
}
.text-warning, .invalid-feedback {
  font-size: 1.2rem;
}
</style>
